export const modalOfIpcTable = {
    alertMessage: 'Up to 50 IPC codes can be selected',
    modalTitle: 'Select IPC codes to search',
    userInputPlaceholder: 'Please enter a keyword or IPC code',
    switchLabel: 'Show only selected IPC codes',
    ipcCode: 'IPC Code',
    ipcSubclass: 'IPC Subclass',
    ipcMainGroup: 'IPC Main Group',
    ipcSubgroup: 'IPC Subgroup',
    factorLoadQuantity: 'Factor Load Quantity',
    numberOfPatents: 'Number of Patent Applications',
    completionButton: 'Done'
}
